import script from "./student-guide.vue?vue&type=script&setup=true&lang=js"
export * from "./student-guide.vue?vue&type=script&setup=true&lang=js"

import "./student-guide.vue?vue&type=style&index=0&id=4a9b77aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9b77aa"]])

export default __exports__